import { IMPERSONATION_TOKEN_KEY } from "@/api/axios.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useEmployeeMe, useImpersonationEnd } from "@/queries/employees/use-employees.query.ts";
import { Button, FontAwesomeIcon, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const { data: employeeMe } = useEmployeeMe();
  const { renderTime } = useFormatter();
  const impersonationEnd = useImpersonationEnd();

  const impersonation = employeeMe?.impersonation;
  if (!employeeMe || !impersonation) return null;

  const employeeName =
    employeeMe.display_name || `${employeeMe.first_name} ${employeeMe.last_name}`;

  const handleExit = async () => {
    try {
      await impersonationEnd.mutateAsync();
    } finally {
      try {
        sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY);
      } catch {
        /* noop */
      }
      window.close();
      window.location.href = "/impersonation-ended";
    }
  };

  return (
    <Stack
      direction={"horizontal"}
      items={"center"}
      justify={"between"}
      gap={"sm"}
      className={"h-10 shrink-0 bg-brand-dark px-4 text-light print:hidden"}
    >
      <Stack direction={"horizontal"} items={"center"} gap={"sm"}>
        <FontAwesomeIcon icon={"fa-light fa-user-secret"} />
        <Text>
          {t("core:impersonation_banner", {
            name: employeeName,
            time: renderTime(impersonation.datetime_valid_to),
          })}
        </Text>
      </Stack>
      <Button
        variant={"plain"}
        onClick={handleExit}
        isLoading={impersonationEnd.isPending}
        className={"text-light hover:text-light"}
        leftIcon={<FontAwesomeIcon icon={"fa-light fa-right-from-bracket"} />}
      >
        {t("core:impersonation_exit")}
      </Button>
    </Stack>
  );
}
